/* eslint-disable @typescript-eslint/no-var-requires */
export const { default: LogoWithoutName } = require('./ic-elites-logo.svg');

